<template>
    <div class="page-container">
        <div class="header-section">
            <span class="header-title">Duyệt level nhân sự</span>
            <div class="d-flex">
                <button
                    v-if="!is_export_excel"
                    class="btn btn-success mr-2"
                    @click="exportExcel"
                >
                    <i class="la la-file-excel"></i> Xuất excel
                </button>
                <button
                    v-else
                    disabled
                    class="btn btn-success mr-2 spinner spinner-white spinner-left"
                >
                    Xuất excel
                </button>
                <button class="btn btn-success mr-2" @click="actionApproveLevel">
                    <i class="fas fa-check"></i> Duyệt level
                </button>
            </div>
        </div>
        <div class="main-content" style="padding: 10px 20px">
            <div class="filter-grid" style="display: grid; gap: 15px; align-items: flex-end; margin: 10px 0">
                <div>
                    <span class="filter-label">Lọc Nhân sự</span>
                    <el-input placeholder="Nhập họ tên, mã nhân sự, sđt" style="width: 100%;"
                              v-model="query.personnel"></el-input>
                </div>
                <div>
                    <span class="filter-label">Lọc phòng ban</span>
                    <el-select v-model="query.team" style="width: 100%;" clearable filterable
                               placeholder="Chọn phòng ban">
                        <el-option v-for="item in teamOptions" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                    </el-select>
                </div>
                <div>
                    <span class="filter-label">Chức vụ</span>
                    <el-select v-model="query.position" style="width: 100%;" clearable filterable
                               placeholder="Chọn chức vụ">
                        <el-option v-for="item in positionOptions" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                    </el-select>
                </div>
                <div>
                    <span class="filter-label">Level</span>
                    <el-select v-model="query.level" style="width: 100%;" clearable filterable placeholder="Chọn level">
                        <el-option v-for="item in levelOptions" :key="item.id" :label="getLevelLabel(item)"
                                   :value="item.id">
                        </el-option>
                    </el-select>
                </div>
                <div>
                    <span class="filter-label">Lọc năm</span>
                    <el-select v-model="query.year" style="width: 100%;" clearable placeholder="Chọn năm">
                        <el-option v-for="item in yearOptions" :key="item.value" :label="item.label"
                                   :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                <div>
                    <span class="filter-label">Lọc quý</span>
                    <el-select v-model="query.quarter" style="width: 100%;" clearable placeholder="Chọn quý">
                        <el-option v-for="item in quarterOptions" :key="item.value" :label="item.label"
                                   :value="item.value">
                        </el-option>
                    </el-select>
                </div>

                <div>
                    <span class="filter-label">Phân loại</span>
                    <el-select v-model="query.type" style="width: 100%;" clearable placeholder="Chọn phân loại">
                        <el-option v-for="item in levelType" :key="item.value" :label="item.label"
                                   :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                <el-button type="primary" style="color: white; width: 120px; height: 40px" @click="querySearch">Tìm
                    kiếm
                </el-button>
            </div>
            <div class="table-responsive mt-8"
                 style="overflow-x:auto; overflow-y:visible; padding-bottom:30px; -webkit-overflow-scrolling:touch;">
                <table class="table" style="text-align:center; min-width:max-content;">
                    <thead>
                    <tr class="table-border">
                        <th scope="col" class="w-150px table-header">Thời gian</th>
                        <th scope="col" class="w-180px table-header">Họ tên</th>
                        <th scope="col" class="w-150px table-header">Mã nhân sự</th>
                        <th scope="col" class="w-150px table-header">Phân loại</th>
                        <th scope="col" class="w-150px table-header">Vị trí</th>
                        <th scope="col" class="w-200px table-header">Phòng ban</th>
                        <th scope="col" class="w-150px table-header">Điểm KRA</th>
                        <th scope="col" class="w-150px table-header">Điểm họp</th>
                        <th scope="col" class="w-150px table-header">Điểm EXP</th>
                        <th scope="col" class="w-150px table-header">Điểm trừ</th>
                        <th scope="col" class="w-150px table-header">Tổng điểm</th>
                        <th scope="col" class="w-150px table-header">Tiêu chí</th>
                        <th scope="col" class="w-180px table-header">Kết quả</th>
                        <th scope="col" class="w-150px table-header">Trạng thái</th>
                        <th scope="col" class="w-150px table-header">Level hiện tại</th>
                        <th scope="col" class="w-150px table-header">Level mới</th>
                        <th scope="col" class="w-150px table-header">Hành động</th>
                    </tr>
                    </thead>
                    <tbody v-if="loading">
                    <tr class="col-12">
                        <td class="text-center">
                            <i class="el-icon-loading loading-container"></i>
                        </td>
                    </tr>
                    </tbody>
                    <tbody v-else-if="listManagementKpi?.length > 0">
                    <tr v-for="item of listManagementKpi" :key="item?.index" class="table-row-border">
                        <td class="table-cell">{{ item?.date ?? 'Chưa có' }}</td>
                        <td class="table-cell" :title="item?.name">{{ item?.name ?? 'Chưa có' }}</td>
                        <td class="table-cell text-uppercase">{{ item?.code }}
                        </td>
                        <td class="table-cell">{{ item?.level_type_name }}</td>
                        <td class="table-cell">{{ item?.currentLevel ?? 'Chưa có' }}</td>
                        <td class="table-cell" :title="item?.team">{{ item?.team ?? 'Chưa có' }}</td>
                        <td class="table-cell">{{ item?.kraScore ?? 'Chưa có' }}</td>
                        <td class="table-cell">{{ item?.meetingScore ?? 'Chưa có' }}</td>
                        <td class="table-cell">{{ item?.exp_points ?? 'Chưa có' }}</td>
                        <td class="table-cell">
                            <el-popover
                                v-if="item.total_minus_point > 0"
                                placement="right"
                                trigger="click"
                                width="360"
                                @show="getDetailMinusPoint(item)"
                            >
                                <div v-if="item._minusLoading" class="py-2 text-center">
                                    <i class="el-icon-loading"></i> Đang tải...
                                </div>

                                <el-empty
                                    v-else-if="!item.minus_point || item.minus_point.length === 0"
                                    description="Không có chi tiết"
                                />

                                <el-table v-else :data="item.minus_point" border size="mini">
                                    <el-table-column prop="point" label="Số điểm trừ" width="120"/>
                                    <el-table-column prop="description" label="Chi tiết"/>
                                </el-table>
                                <span
                                    slot="reference"
                                    class="cursor-pointer"
                                    :class="item.total_minus_point > 0 ? 'text-danger' : 'text-success'"
                                >
                                  -{{ item.total_minus_point }}
                                </span>
                            </el-popover>
                            <span v-else :class="item.total_minus_point > 0 ? 'text-danger' : 'text-success'">
                                {{ item.total_minus_point }}
                              </span>
                        </td>

                        <td class="table-cell">{{ item?.totalScore ?? 'Chưa có' }}</td>
                        <td class="table-cell">{{
                                item?.professional_criteria
                                ??
                                'Chưa có'
                            }}
                        </td>
                        <td class="table-cell">
                            <div class="w-100" style="font-weight: 700"
                                 :class="expectedDefineColor[item.approve_type]">
                                {{ expectedDefineText[item.approve_type] }}
                                <i style="font-weight:800; margin-left: 5px; color: inherit !important"
                                   :class="expectedDefineIcon[item.approve_type]"></i>
                            </div>
                        </td>
                        <td class="table-cell">
                            <el-button size="mini"
                                       :style="{ backgroundColor: getStatus(item).color, color: getStatus(item).text }"
                                       :type="getStatus(item).type" class="btn-approve-level w-100">
                                {{ getStatus(item).label }}
                            </el-button>
                        </td>
                        <td class="table-cell" :title="item?.position">{{ item?.position ?? 'Chưa có' }}</td>
                        <td class="table-cell">{{ item?.newProfessionalLevel ?? 'Chưa có' }}</td>
                        <td>
                            <button class="btn btn-xs btn-icon btn-outline-success"
                                    @click="showProgress(item.user_id)"
                                    title="Xem chi tiết">
                                <i class="far fa-eye"></i>
                            </button>
                        </td>
                    </tr>
                    </tbody>
                    <tbody v-else>
                    <tr class="no-data-container">
                        <label class="no-data-label">Chưa có dữ liệu</label>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div v-if="listManagementKpi?.length > 0">
                <div class="edu-paginate mx-auto text-center mt-10 mb-5 pagination-container">
                    <paginate v-model="page" :page-count="last_page" :page-range="3" :margin-pages="1"
                              :click-handler="clickCallback" :prev-text="'Trước'" :next-text="'Sau'"
                              :container-class="'pagination b-pagination'" :pageLinkClass="'page-link'"
                              :next-link-class="'next-link-item'" :prev-link-class="'prev-link-item'"
                              :prev-class="'page-link'" :next-class="'page-link'" :page-class="'page-item'">
                    </paginate>
                </div>
                <div class="w-100 total-records">
                    Tổng số bản ghi: <span class="total-count">{{ this.total }}</span>
                </div>
            </div>
        </div>

        <!-- Approve Level Modal -->
        <ApproveLevelModal ref="approveModal" :visible="showApproveModal" @close="handleCloseModal"
                           @confirm="handleConfirmApprove"/>

        <el-dialog
            class="responsive teacher-day"
            :visible.sync="outerVisible"
            :title="dialogTitle"
            @close="clearForm"
            :close-on-click-modal="false"
            destroy-on-close
            top="5vh"
            width="70%"
        >
            <div v-loading="dialogLoading" class="w-100">
                <el-tabs v-model="activeMonth" type="card">
                    <el-tab-pane
                        v-for="m in quarterMonths"
                        :key="m.month"
                        :name="String(m.month)"
                        :label="m.label"
                    >
                        <div>
                            <span style="font-weight: 700">Điểm trung bình: {{ totalScore[m.month] }} %</span>
                        </div>
                        <div class="mt-2">
                            <el-table
                                :data="(reviewFormByMonth[m.month] && reviewFormByMonth[m.month].criteria) ? reviewFormByMonth[m.month].criteria : []"
                                stripe
                                border
                                size="mini"
                                :row-key="'id'"
                            >
                                <el-table-column
                                    prop="criteria_name"
                                    label="Tiêu chí"
                                    min-width="220"
                                />
                                <el-table-column label="Link báo cáo" min-width="240">
                                    <template slot-scope="{ row }">
                                        <el-input
                                            v-model="row.report_link"
                                            type="textarea"
                                            :rows="3"
                                            disabled
                                            placeholder="Nhập link báo cáo..."
                                            clearable
                                            @change="handleChangeLink(row.id, $event)"
                                        />
                                    </template>
                                </el-table-column>
                                <el-table-column label="Kết quả đạt thực tế" min-width="180">
                                    <template slot-scope="{ row }">
                                        <el-input-number
                                            v-model="row.score_actual"
                                            :min="0"
                                            :step="1"
                                            :controls="false"
                                            :value-on-clear="null"
                                            disabled
                                            style="width: 100%"
                                            @change="handleChangeScore(row.id, $event)"
                                        /><span class="absolute mt-2" style="margin-left: -20px">%</span>
                                    </template>
                                </el-table-column>

                                <el-table-column label="Kết quả KPI chỉ số " min-width="180">
                                    <template slot-scope="{ row }">
                                        <el-input-number
                                            v-model="row.score_conversion"
                                            :min="0"
                                            :step="1"
                                            :controls="false"
                                            :value-on-clear="null"
                                            disabled
                                            style="width: 100%"
                                        /><span class="absolute mt-2" style="margin-left: -20px">%</span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="Trạng thái" min-width="100">
                                    <template slot-scope="{ row }">
                                        <el-button
                                            class="text-white"
                                            v-if="row.status"
                                            :type="taskMeta(row.status).type"
                                            size="mini"
                                        >
                                            {{ taskMeta(row.status).label }}
                                        </el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </el-tab-pane>
                </el-tabs>
            </div>

        </el-dialog>
    </div>
</template>

<script>
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";
import {
    APPROVE_LEVELS,
    EXPORT_TEAMLEAD_SCORE_REVIEW,
    GET_APPROVE_LEVEL_LIST,
    GET_DETAIL_MINUS_POINT,
    GET_LEVELS,
    GET_TEAMS
} from "@/core/services/store/approve-level/approveLevel.module";

import ApproveLevelModal from "./modal/ApproveLevelModal.vue";
import "./styles.css";
import {TEAMLEAD_SCORE_REVIEW} from "../../../core/services/store/level/level.module";
import {exportExcel} from "@/core/filters";

export default {
    name: 'ApproveLevel',
    components: {ApproveLevelModal},
    mounted() {
        this.$store.dispatch(SET_BREADCRUMB, [
            {title: "Quản lý", icon: 'far fa-info-square'},
            {title: "Duyệt level nhân sự", icon: 'fas fa-list'}
        ]);
        this.getApproveLevelList();
        this.getTeams();
        this.getLevels();
        this.getCurrentsYear();
    },
    data() {
        return {
            query: {
                personnel: null,
                team: null,
                position: null,
                level: null,
                year: null,
                quarter: null,
                type: ''
            },
            loading: true,
            teamOptions: [],
            positionOptions: [
                {id: 14, name: 'Nhân viên'},
                {id: 34, name: 'Trưởng nhóm'},
                {id: 32, name: 'Trưởng bộ phận'},
                {id: 16, name: 'Trưởng phòng'},
            ],
            levelOptions: [],
            yearOptions: [],
            quarterOptions: [
                {value: 1, label: 'Quý I'},
                {value: 2, label: 'Quý II'},
                {value: 3, label: 'Quý III'},
                {value: 4, label: 'Quý IV'}
            ],
            levelType: [
                {value: 1, label: 'Chuyên môn'},
                {value: 2, label: 'Quản trị'}
            ],
            listManagementKpi: [],
            page: 1,
            last_page: 1,
            total: 0,
            showApproveModal: false,
            expectedDefineIcon: {1: 'el-icon-top', 2: 'el-icon-bottom', 3: 'fas fa-square'},
            expectedDefineText: {1: 'Tăng Level', 2: 'Giảm Level', 3: 'Giữ Nguyên Level'},
            expectedDefineColor: {1: 'text-success', 2: 'text-danger', 3: 'text-warning'},
            statusMap: {
                1: {label: 'Đã duyệt', color: '#7ED957', type: '', text: '#FFFFFF'},
                2: {label: 'Chưa duyệt', color: '#F0F0F0', type: '', text: '#7351B8'}
            },
            dialogLoading: false,
            dialogTitle: 'Kết quả chỉ số',
            activeMonth: '1',
            quarterMonths: [],
            reviewFormByMonth: {},
            _reviewRawMonths: [],
            _reviewSource: null,
            outerVisible: false,
            totalScore: [],
            is_edit: false,
            task_meta: {
                1: { type: 'info',  label: 'Không đạt' },
                2: { type: 'primary', label: 'Đạt' },
                3: { type: 'success', label: 'Vượt' },
            },
            is_export_excel: false,
        }
    },
    methods: {
        exportExcel() {
            this.is_export_excel = true;
            const params = {
                year: this.query.year ? +this.query.year : null,
                quarter: this.query.quarter ? +this.query.quarter : null,
            };
            const HEADER_ROW_EXPORT_APPROVE_LEVEL = [
                { key: 'user_id', value: 'Mã nhân sự' },
                { key: 'user_name', value: 'Họ tên' },
                { key: 'department_name', value: 'Phòng ban' },
                { key: 'year', value: 'Năm' },
                { key: 'month', value: 'Tháng' },
                { key: 'criteria_name', value: 'Tiêu chí' },
                { key: 'task', value: 'Nhiệm vụ' },
                { key: 'type_text', value: 'Phân loại' },
                { key: 'score_standard', value: 'Điểm chuẩn (%)' },
                { key: 'score_actual', value: 'Kết quả đạt thực tế (%)' },
                { key: 'score_conversion', value: 'Kết quả KPI chỉ số (%)' },
                { key: 'report_link', value: 'Link báo cáo' },
                { key: 'status_text', value: 'Trạng thái' },
                { key: 'count_level', value: 'Số bậc tăng/giảm' },
            ];

            this.$store.dispatch(EXPORT_TEAMLEAD_SCORE_REVIEW, params).then((res) => {
                this.is_export_excel = false;
                if (res?.error) {
                    this.$bvToast?.toast?.(res?.message || "Có lỗi xảy ra", {
                        title: "Export excel",
                        variant: "danger",
                        solid: true,
                    });
                    return;
                }
                exportExcel(
                    HEADER_ROW_EXPORT_APPROVE_LEVEL,
                    res?.data || res || [],
                    `Duyet-level-${params.year || "all"}-Q${params.quarter || "all"}.xlsx`,
                    false
                );
            }).catch((error) => {
                this.is_export_excel = false;
                this.$bvToast?.toast?.(error?.data?.message || "Export thất bại", {
                    title: "Export excel",
                    variant: "danger",
                    solid: true,
                });
            });
        },
        getCurrentsYear() {
            const now = new Date();
            const y = now.getFullYear(), s = 2025;
            this.yearOptions = Array.from({length: Math.max(1, y - s + 1)}, (_, i) => ({
                value: s + i,
                label: (s + i).toString()
            }));
        },
        getLevelLabel(item) {
            if (item.level_type == 1) {
                return `Chuyên môn - ${item.level}`;
            } else if (item.level_type == 2) {
                return `Quản trị - ${item.level}`;
            }
            return item.level;
        },
        convertToRoman(quarter) {
            const romanNumerals = {
                1: 'I',
                2: 'II',
                3: 'III',
                4: 'IV'
            };
            return romanNumerals[quarter] || quarter;
        },
        clickCallback(obj) {
            this.page = obj;
            this.getApproveLevelList()
        },
        callApi() {
            this.loading = true;
            const payload = {
                keyword: this.query.personnel,
                department_id: this.query.team ? +this.query.team : null,
                account_type_id: this.query.position ? +this.query.position : null,
                current_level: this.query.level ? +this.query.level : null,
                year: this.query.year ? +this.query.year : null,
                type: this.query.type ? +this.query.type : null,
                quarter: this.query.quarter ? +this.query.quarter : null,
                page: this.page,
            }
            this.$store.dispatch(GET_APPROVE_LEVEL_LIST, payload).then(res => {
                const data = res?.data?.data
                if (!res.data.error) {
                    this.total = res.data.total
                    this.last_page = res.data.last_page;
                    this.listManagementKpi = data.map(item => this.transformData(item)) ?? []
                }
            }).catch(e => {
                console.log(e, 'approve level error')
            }).finally(() => {
                this.loading = false
            });
        },
        querySearch() {
            this.updateURL();
            this.callApi()
        },
        getApproveLevelList() {
            this.getParams();
            this.callApi()
        },
        getTeams() {
            this.$store.dispatch(GET_TEAMS).then(res => {
                this.teamOptions = res.data || [];
            }).catch(e => {
                console.log(e, 'get teams error');
            });
        },
        getLevels() {
            this.$store.dispatch(GET_LEVELS).then(res => {
                this.levelOptions = res.data || [];
            }).catch(e => {
                console.log(e, 'get levels error');
            });
        },
        getParams() {
            const now = new Date();

            this.query.personnel = this.$route.query.keyword || null
            this.query.team = this.$route.query.team_id ? parseInt(this.$route.query.team_id) : null
            this.query.position = this.$route.query.position_id ? parseInt(this.$route.query.position_id) : null
            this.query.level = this.$route.query.level_id ? parseInt(this.$route.query.level_id) : null
            this.query.type = this.$route.query.type ? parseInt(this.$route.query.type) : null

            // Nếu có query year thì lấy, không thì set năm hiện tại
            this.query.year = this.$route.query.year ? parseInt(this.$route.query.year) : now.getFullYear()

            // Nếu có query quarter thì lấy, không thì set quý hiện tại
            this.query.quarter = this.$route.query.quarter ? parseInt(this.$route.query.quarter) : (Math.floor(now.getMonth() / 3) + 1)
        },
        updateURL() {
            const newQuery = {
                keyword: this.query.personnel || null,
                team_id: this.query.team || null,
                position_id: this.query.position || null,
                level_id: this.query.level || null,
                year: this.query.year || null,
                quarter: this.query.quarter || null,
                type: this.query.type || null,
            };

            if (JSON.stringify(this.$route.query) !== JSON.stringify(newQuery)) {
                this.$router.push({
                    name: 'approve-level',
                    query: newQuery
                });
            }
        },
        transformData(item) {
            return {
                ...item,
                code: item?.user_id ? item.user_id + 100000 : item?.code,
                name: item?.user?.name || item?.name,
                position: item?.user?.profile?.account_type?.name || item?.position,
                currentLevel: item?.current_level?.level || item?.currentLevel,
                team: item?.department?.name || item?.team,
                kraScore: item.kra_score ? `${item.kra_score}/100` : (item?.kraScore || 'Chưa có'),
                meetingScore: item?.meeting_points ? `${item.meeting_points}/10` : (item?.meetingScore || 'Chưa có'),
                date: item?.quarter && item?.year ? 'Quý ' + this.convertToRoman(item.quarter) + '/' + item.year : item?.date,
                totalScore: this.getSumScore(item, 1),
                newProfessionalLevel: item?.requested_level?.level,
                level_type_name: item?.level_type == 1 ? 'Chuyên môn' : item?.level_type == 2 ? 'Quản trị' : 'Chưa có',
            };
        },
        getSumScore(r, t = 1) {
            const n = x => (+x || 0), s = n(r?.kra_score) + n(r?.meeting_points) + n(r?.exp_points),
                up = n(r?.requested_level?.score), down = n(r?.requested_level?.demote_score);
            return t === 1 ? (up > 0 ? `${s}/${up}` : `${s}`) : (s >= up ? 1 : s < down ? 3 : 2);
        },
        getStatus(item) {
            let status = 2;
            if (item.approved_at) {
                status = 1;
            }
            return this.statusMap[status];
        },
        actionApproveLevel() {
            this.showApproveModal = true;
        },
        handleCloseModal() {
            this.showApproveModal = false;
        },
        async handleConfirmApprove(data) {
            console.log('Approving levels for:', data);

            try {
                await this.$store.dispatch(APPROVE_LEVELS, data);

                // Show success message
                this.$message({
                    type: 'success',
                    message: `Đã duyệt level cho nhân sự năm ${data.year}, quý ${data.quarter}`
                });

                // Close modal after success
                this.showApproveModal = false;

                // Refresh the list
                this.getApproveLevelList();

            } catch (error) {
                console.error('Error approving levels:', error);
                this.$message({
                    type: 'error',
                    message: 'Có lỗi xảy ra khi duyệt level. Vui lòng thử lại!'
                });
            } finally {
                // Reset loading state in modal
                if (this.$refs.approveModal) {
                    this.$refs.approveModal.resetLoadingState();
                }
            }
        },
        getDetailMinusPoint(item) {
            this.$set(item, '_minusLoading', true);
            const payload = {
                user_id: item.user_id,
                year: item.year,
                quarter: item.quarter,
            };
            this.$store.dispatch(GET_DETAIL_MINUS_POINT, payload).then(res => {
                item.minus_point = res?.data;
                this.$set(item, '_minusLoading', false);
            }).catch(e => {
                console.error(e);
            });
        },
        showProgress(user_id)
        {

            this.buildEmptyQuarterForm(this.query.quarter);
            this.fetchTeamleadReview(user_id);

        },
        fetchTeamleadReview(user_id) {
            this.outerVisible = true;

            if (!user_id) return;
            this.dialogLoading = true;

            let payload = {
                quarter: this.query.quarter,
                year: this.query.year,
                user_id: user_id,
            }

            this.$store.dispatch(TEAMLEAD_SCORE_REVIEW, payload)
                .then((res) => {
                    const reviewRaw = res?.data ?? res;
                    this._reviewSource = reviewRaw;

                    const months = this.extractMonthsArray(reviewRaw);
                    this._reviewRawMonths = Array.isArray(months) ? months : [];
                    this.fillQuarterFormFromRaw(this._reviewRawMonths);
                    console.log(res, 'res')
                })
                .catch((response) => {
                    console.log(response, 'response')
                    // Nếu backend không trả đúng format, form vẫn rỗng để user vẫn có thể nhập
                    this.$notify.error({
                        title: 'Thất bại',
                        message: 'Không tải được dữ liệu review theo quý. Vui lòng thử lại.',
                        type: 'error',
                    });
                })
                .finally(() => {
                    this.dialogLoading = false;
                });
        },
        taskMeta(status) {
            return this.task_meta[status] || '';
        },
        extractMonthsArray(reviewRaw) {

            if (!reviewRaw) return [];
            // Backend đôi khi trả thẳng dạng array: [{month:1, criteria:[...]}, ...]
            if (Array.isArray(reviewRaw)) return reviewRaw;


            const candidates = [
                reviewRaw?.months,
                reviewRaw?.data?.months,
                reviewRaw?.data?.results_months,
                reviewRaw?.details,
                reviewRaw?.data_detail,
                reviewRaw?.month_results,
                reviewRaw?.results,
                reviewRaw?.data?.details,
            ];

            const found = candidates.find((c) => Array.isArray(c));
            return Array.isArray(found) ? found : [];
        },
        getQuarterMonths(quarter) {
            // Quarter -> months
            if (+quarter === 1) return [1, 2, 3];
            if (+quarter === 2) return [4, 5, 6];
            if (+quarter === 3) return [7, 8, 9];
            if (+quarter === 4) return [10, 11, 12];
            return [1, 2, 3];
        },
        buildEmptyQuarterForm(quarter) {
            const months = this.getQuarterMonths(quarter);
            this.quarterMonths = months.map((m) => ({
                month: m,
                label: `Tháng ${m}`,
            }));

            const form = {};
            months.forEach((m) => {
                form[m] = {
                    criteria: [],
                    __rawMonthRef: null,
                };

                this.$set(this.totalScore, m, 0);
            });
            console.log(form, 'form')
            this.reviewFormByMonth = form;
            this.activeMonth = String(months[0]);
        },
        fillQuarterFormFromRaw(monthObjects) {
            const months = Array.isArray(monthObjects) ? monthObjects : [];

            this.quarterMonths.forEach(({ month }) => {
                const monthObj = months.find((x) => {
                    const n =
                        Number(x?.month ?? x?.month_number ?? x?.period_month ?? x?.m ?? x?.index);
                    return n === Number(month);
                });

                if (!monthObj) return;
                const criteria = Array.isArray(monthObj.criteria) ? monthObj.criteria : [];

                if (this.reviewFormByMonth[month]) {
                    // Normalize fields so `el-input-number` / `el-input` always bind safely
                    criteria.forEach((c) => {
                        if (c.score_standard === undefined) this.$set(c, 'score_standard', 0);
                        if (c.score_conversion === undefined) this.$set(c, 'score_conversion', null);
                        if (c.score_actual === undefined) this.$set(c, 'score_actual', null);
                        if (c.report_link === undefined || c.report_link === null) this.$set(c, 'report_link', '');

                        // Coerce to expected types for Element UI inputs
                        if (c.score_standard !== null && c.score_standard !== undefined && c.score_standard !== '') {
                            this.$set(c, 'score_standard', Number(c.score_standard));
                        } else {
                            this.$set(c, 'score_standard', 0);
                        }
                        if (c.score_conversion === null || c.score_conversion === undefined || c.score_conversion === '') {
                            this.$set(c, 'score_conversion', undefined);
                        } else {
                            this.$set(c, 'score_conversion', Number(c.score_conversion));
                        }
                        if (c.score_actual === null || c.score_actual === undefined || c.score_actual === '') {
                            this.$set(c, 'score_actual', undefined);
                        } else {
                            this.$set(c, 'score_actual', Number(c.score_actual));
                        }

                        if (c.report_link !== null && c.report_link !== undefined) {
                            this.$set(c, 'report_link', String(c.report_link));
                        } else {
                            this.$set(c, 'report_link', '');
                        }
                    });

                    this.$set(this.reviewFormByMonth[month], 'criteria', criteria);
                    this.$set(this.reviewFormByMonth[month], '__rawMonthRef', monthObj);

                    // Recalculate total for this month
                    this.calculateTotalScoreForMonth(month);
                }
            });
        },
        calculateTotalScoreForMonth(month) {
            const criteria = this.reviewFormByMonth?.[month]?.criteria || [];
            const sum = criteria.length ? criteria.reduce((acc, c) => acc + (Number(c?.score_conversion) || 0), 0) / criteria.length : 0;
            this.$set(this.totalScore, month, sum.toFixed(2));
        },
        clearForm() {
            this.dialogLoading = false;
            this.saving = false;
            this.selectedUserForDialog = { userId: null, userName: '', year: null, quarter: 1 };
            this.dialogTitle = 'Kết quả chỉ số';
            this.activeMonth = '1';
            this.quarterMonths = [];
            this.reviewFormByMonth = {};
            this.totalScore = [];
            this._reviewRawMonths = [];
            this._reviewSource = null;
        },

    }
}
</script>
